module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("I Hope You Dance: A Year of Weddings Novella")]), _c('link', {
    attrs: {
      "href": "styles/default.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "ser1",
    attrs: {
      "id": "pA5"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/contents#bb_1",
      "id": "aa_1"
    }
  }, [_c('img', {
    attrs: {
      "alt": "images/img-5-1.jpg",
      "id": "AtB",
      "src": "images/img-5-1.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "pz5-2"
    }
  }, [_c('span', {
    staticClass: "tx1a"
  }, [_c('i', [_vm._v("I have enjoyed reading each one of the Year of Weddings")])]), _vm._v(" novellas as they have released, and I was delighted to be invited to participate in the second year, especially since it allowed me to return to Kings Meadow once again.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz5-3"
    }
  }, [_vm._v("And a special thanks to Ami McConnell, who championed all of the stories set in Kings Meadow.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-baaaf0e8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter01.vue
// module id = 69
// module chunks = 0